// src/app/modules/AccessControl/pages/access-logs-table/column-formatters/StatusColumnFormatter.jsx
import React from "react";

const STATUS_MAP = {
  checked_in:  { pill: 'sety-pill-green',  label: 'Checked In' },
  checked_out: { pill: 'sety-pill-purple', label: 'Checked Out' },
  denied:      { pill: 'sety-pill-red',    label: 'Denied' },
  on_break:    { pill: 'sety-pill-amber',  label: 'On Break' },
};

export function StatusColumnFormatter(cellContent, row) {
  const { pill, label } = STATUS_MAP[row.status] || { pill: 'sety-pill-grey', label: cellContent };
  return <span className={`sety-pill ${pill}`}>{label}</span>;
}
